<!-- <div class="d-flex align-items-center" (mouseleave)="showUserOptionDropdown=false">
    <div class="dropdown">
        <button class="btn btn-light-blue dropdown-toggle" (mouseenter)="showUserOptionDropdown=true" >
            {{ user.name }}
        </button>
        @if(showUserOptionDropdown){
        <ul class="dropdown-menu" [ngClass]="{'show': showUserOptionDropdown}" aria-labelledby="userDropdown">
            <li><a class="dropdown-item" (click)="goToProfile()">Profile Details</a></li>
            @if(isAdmin && !router.url.includes('admin-panel')){
            <li><a class="dropdown-item" (click)="navigate()">Switch to Admin Panel</a></li>
            }
            @else if( (user.isContributor===1 || user.isReviewer===1) && router.url.includes('admin-panel')) {
            <li><a class="dropdown-item" (click)="navigate()">Switch to Contributor</a></li>

            }

            <li><a class="dropdown-item" (click)="logout()">Sign Out</a></li>
        </ul>
        }
    </div>

</div> -->


<!--<div class="absolute right-0 w-60 top-12 max-w-60 overflow-hidden rounded-2xl bg-white shadow-lg pb-3  ease-in-out duration-200 opacity-0" [ngClass]="dropdownMenuState? 'opacity-100 translate-y-0 visible': 'translate-y-7 invisible'">-->


@if (!isUserSession) {
  <ul class="grid grid-cols-2 gap-2.5 w-full px-5 py-4 border-b border-ThemeGainsboro lg:hidden block">
    <li><a [routerLink]="['/auth/login']"  class="bg-[#EFEFF1] text-black font-medium text-sm rounded-full py-2 flex justify-center items-start text-nowrap">Log in</a></li>
    <li><a [routerLink]="['/auth/signup']" class="bg-themeBlackTwo text-white font-medium text-sm rounded-full py-2 flex justify-center items-start text-nowrap">Create free Account</a></li>
  </ul>
}


@if (isUserSession) {

        <div class="p-4 border-b border-ThemeGainsboro">
          @if(user.isProSubscription===1){
            <span class="rounded-3xl bg-themeBlackTwo uppercase py-[3px] px-[10px] leading-3 text-white text-[10px] font-medium inline-block">pro</span>
          }
          <p class="text-black font-semibold text-base leading-5 mt-2">{{user.name}}</p>
          <p class="text-themeDarkGrayTwo font-normal text-base leading-6 mt-1 truncate">{{user.email}}</p>
          <button class="bg-ThemeWhisper text-themeBlackTwo font-semibold text-sm rounded-full mt-3 py-[10px] w-full" (click)="goToProfile()">View profile</button>
        </div>
    }

      <ul class="flex flex-col text-themeNero  divide-y divide-ThemeGainsboro rounded-2xl">
        <li class="w-full cursor-pointer"><a [routerLink]="['/profile/pricing']" class="py-[10px] px-[18px] text-sm lg:font-semibold font-normal block">Plans and Billing</a></li>
        <!-- <li class="w-full"><a [routerLink]="['/mit-license']" class="py-[10px] px-[18px] text-sm lg:font-semibold font-normal block">License</a></li> -->
        <!-- @if(isAdmin && !router.url.includes('admin-panel') && this.isUserLogin){
            <li class="w-full"><a href="javascript:void(0)" class="py-[10px] px-[18px] text-sm lg:font-semibold font-normal block" (click)="navigate()">Switch to Admin Panel</a></li>
        } -->

        @if(canSwitchToAdminPanel){
            <li class="w-full"><a [routerLink]="[adminPanelEntryRoute]" class="py-[10px] px-[18px] text-sm lg:font-semibold font-normal block">Switch to Admin Panel</a></li>
        }

        @if(this.isContributor){

          <li class="w-full"><a [routerLink]="['/profile/contributor/upload']"  class="py-[10px] px-[18px] text-sm lg:font-semibold font-normal block">Become a contributor</a></li>
        }
        @if (isUserSession) {
            <li class="w-full"><a [routerLink]="['/profile/downloads']" class="py-[10px] px-[18px] text-sm lg:font-semibold font-normal block">My Downloads</a></li>
        }
        @if (isUserSession) {
            <li class="w-full"><a [routerLink]="['/profile/collections']" class="py-[10px] px-[18px] text-sm lg:font-semibold font-normal block">My Collections</a></li>
        }
        
        <li class="w-full"><a [routerLink]="['/contact-us']" class="py-[10px] px-[18px] text-sm lg:font-semibold font-normal block">Contact us</a></li>

         <li class="w-full">
                <div class="py-[10px] px-[18px] flex justify-start items-center gap-2">
                  <a [routerLink]="['/terms-of-use']" class="inline-block text-themeDimGrayTwo font-semibold text-xs leading-5">Terms</a>
                  <a [routerLink]="['/standard-commercial-license']" class="inline-block text-themeDimGrayTwo font-semibold text-xs leading-5">License</a>
                  <a [routerLink]="['/privacy-policy']" class="inline-block text-themeDimGrayTwo font-semibold text-xs leading-5">Privacy</a>
                </div>
              </li>
        @if (isUserSession) {
            <li class="w-full"><a href="javascript:void(0)" class="py-[10px] px-[18px] text-sm lg:font-semibold font-normal block text-red-500" (click)="logout()">Logout</a></li>
        }

        <div class="relative">



</div>
        <!-- @else {
            <li class="w-full">
                <div class="py-[10px] px-[18px] flex gap-2">
                  <a href="javascript:void(0)" class="inline-block text-themeDimGrayTwo">Privacy</a>
                  <a href="javascript:void(0)" class="inline-block text-themeDimGrayTwo">Terms</a>
                </div>
              </li>
        } -->
      </ul>
<!--  </div>-->

  <!-- (click)="sendValue()" -->
